import { ExplorationsRoot, ExplorationsState } from '@mode/legacy/types-app-state';
import { combineAllReducers } from '@mode/legacy/util-domain';
import { Actions } from '../actions';
import { ExplorationsActionType } from '../actions/exploration/explorations.actions';

export const initialExplorationsState: ExplorationsState = {
  allExplorationsList: [],
};

export function explorationsListReducer(
  state = initialExplorationsState.allExplorationsList,
  action: Actions
): ExplorationsState['allExplorationsList'] {
  switch (action.type) {
    case ExplorationsActionType.LoadAllExplorations:
      return action.explorations;
    case ExplorationsActionType.DeleteExplorationSuccess:
      const tempState = [...state];
      const deletedExplorationIndex = tempState.findIndex((exp) => exp.token === action.explorationToken);
      tempState.splice(deletedExplorationIndex, 1);
      return tempState;
  }

  return state;
}

export const explorationsReducers = {
  allExplorationsList: explorationsListReducer,
};

export const explorationsFeatureReducer = combineAllReducers<ExplorationsRoot, keyof ExplorationsRoot, Actions>({
  explorations: explorationsReducers,
});
